import { theme } from "@bounce/theme"

import { useMediaQuery } from "./useMediaQuery"

export const useIsMobile = () => {
  const isMobile = useMediaQuery(`(max-width: ${theme.spacing("screen-sm")}px)`)

  return isMobile
}
